import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import CustomFieldValue from "@mapmycustomers/shared/types/customField/CustomFieldValue";

const customFieldsToFormValues = (
  customFields?: CustomFieldValue[]
): Record<CustomField["esKey"], CustomFieldValue> =>
  (customFields ?? []).reduce((result, value) => ({ ...result, [value.esKey]: value }), {});

export default customFieldsToFormValues;
